import { Document, Packer } from "docx";
import { saveAs } from "file-saver";

export const exportDoc = async (children: any[], fileName: string) => {
    const doc = new Document({
        sections: [{
            properties: {},
            children,
        }],
    });

    Packer.toBlob(doc).then(blob => {
        saveAs(blob, `${fileName}.docx`);
    });
}